import moment from 'moment-timezone';
import inspectionApi from '../services/api/inspectionApi';
import { CLOSED, IN_PROGRESS } from '../constants/statuses';
import date from '../services/ui/date';

export const RESET = 'EDIT_VISIT_DETAILS/RESET';
export const FORM_REFRESHED = 'EDIT_VISIT_DETAILS/FORM_REFRESHED';

export const formRefreshed = (form) => ({
    type: FORM_REFRESHED,
    form,
});

export const reset = () => ({ type: RESET });

export const onMarkAsCompleteChange = (isComplete, setFieldValue) => {
    const completedDate = isComplete ? moment().utc().format() : null;
    const statusId = isComplete ? CLOSED : IN_PROGRESS;

    setFieldValue('is_complete', isComplete);
    setFieldValue('completed_date', completedDate);
    setFieldValue('status_id', statusId);
};

export const onSubmit = async (
    values,
    { setSubmitting, setErrors, resetForm },
    onSuccess
) => {
    try {
        const payload = {
            ...values,
        };

        if (values.inspection_date) {
            payload.inspection_date = date.server(values.inspection_date);
        }
        if (values.completed_date) {
            payload.completed_date = date.server(values.completed_date);
        }

        await inspectionApi.update(values.id, payload);

        setSubmitting(false);
        resetForm();
        onSuccess();
    } catch ({ response }) {
        setSubmitting(false);
        setErrors({
            inspection_date: response.data.errors.inspection_date
                ? response.data.errors.inspection_date[0]
                : null,
            reference: response.data.errors.reference
                ? response.data.errors.reference[0]
                : null,
        });
    }
};
